import React from "react";
import { useLocation, useParams } from "react-router-dom";

import { useGameParamsContext } from "supercell-frontend-base/src/stores/gameParams";
import { SquadBustersGameParams } from "../../validation/game-params";
import { useSnowplowContext } from "supercell-frontend-base/src/analytics/snowplow";

import { getProps } from "./get-props";

import { ArticleView } from "./view";

type Params = { id: string; variant?: string; slug?: string };

export const ArticleController = () => {
    const { pathname: pagePath } = useLocation();
    const { gameParams } = useGameParamsContext<SquadBustersGameParams>();
    const { id, variant, slug } = useParams<Params>();
    const { trackPageView } = useSnowplowContext();

    const isolated =
        (variant && variant.toLowerCase() === "isolated") ||
        (slug && slug.toLowerCase() === "isolated");

    const track = (article) => {
        trackPageView(article?.title ?? "", pagePath);
    };

    const props = {
        getProps: getProps(id, isolated, gameParams),
        id,
        track,
    };

    return <ArticleView {...props} />;
};
